import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../utils/Auth';
import { useOrganization } from '../../../utils/OrganizationContext';
import { useUserPermissions } from '../../../utils/hooks/useUserPermissions';
import { useWindowSize } from '../../../utils/hooks/useWindowSize';
import { useLocalStorage } from '../../../utils/hooks/useLocalStorage';
import styles from './AddBtn.module.css';

export default function AddBtn(props) {

    const { activeQRs, liquidQRLength } = props;
    const { width } = useWindowSize();
    const { orgObj } = useAuth();
    const { orgMetadata } = useOrganization();
    const { canEditQR } = useUserPermissions();
    const navigate = useNavigate();
    const [ storedQrType, setStoredQrType ] = useLocalStorage('qr_type');
    
    const [ showAdd, setShowAdd ] = useState(false);
    const [ disableNewBtn, setDisableNewBtn ] = useState(false);

    const isPersonalOrg = orgObj?.metadata?.type === 'personal';
    const isAccountExpired = !isPersonalOrg && orgMetadata?.active === false;

    useEffect(() => {
        setDisableNewBtn(orgObj?.plan?.liquid_qrs <= liquidQRLength);

        return () => setDisableNewBtn(false);
    },[activeQRs, liquidQRLength, orgObj?.plan]);

    const handleShowAdd = () => {
        let btn = document.querySelector(`.${styles.addBtn}`);
        setShowAdd(true);

        btn?.classList.add(styles.stretch);
    };

    const handleHideAdd = () => {
        setShowAdd(false);
        let btn = document.querySelector(`.${styles.addBtn}`);
        btn.classList.remove(styles.stretch);
    };

    const handleAddQR = () => {
        if (!canEditQR || isAccountExpired) {
            return;
        }
        setStoredQrType(null);
        navigate('/collection/new');
        setShowAdd(false);
    };

    return (
        <>
        <button
            className={styles.addBtn}
            onMouseEnter={width > 768 ? handleShowAdd : null}
            onMouseLeave={width > 768 ? handleHideAdd : null}
            onClick={handleAddQR}
            disabled={disableNewBtn || !canEditQR || isAccountExpired}
            title={isAccountExpired ? 'Account expired. Visit Organization Settings to reup your subscription.' : (!canEditQR ? 'You do not have permission to create QR codes.' : undefined)}
        >
            {showAdd && <span className={styles.addContent}>New</span> }
            <i className='fas fa-plus' style={{pointerEvents: 'none'}} />
        </button>
        {activeQRs?.length === 0 && (
            <div className={styles.shineWrap}>
                <i className='fa-thin fa-certificate fa-spin' />
            </div>
        )}
        </>
    );
};